export const STATUS_ELIGIBLE = 'ELIGIBLE' as const;
export const STATUS_INELIGIBLE = 'INELIGIBLE' as const;

export const REASON_NOT_IN_COHORT = 'NOT_IN_COHORT' as const;
export const REASON_FEATURE_DISABLED = 'FEATURE_DISABLED' as const;
